/******************************************************************************
 * Created Date: Wednesday Febuary 16th 2022                                  *
 * Author: Jan A.                                                             *
 * -----                                                                      *
 * Last Modified: Wed Feb 16 2022                                             *
 * Modified By: Jan A.                                                        *
 * -----                                                                      *
 * File: /src/components/account/Users/components/ToolBar/index.jsx           *
 * Copyright (c) 2021 Kuva                                                    *
 ******************************************************************************/

import PropTypes from "prop-types";
import { Box, IconButton, Button, TextField } from "@mui/material";
import { Clear as ClearIcon, Search as SearchIcon } from "@mui/icons-material";

function ToolBar(props) {
  return (
    <Box style={{ margin: "20px" }}>
      <TextField
        variant="standard"
        value={props.value}
        onChange={props.onChange}
        placeholder="Search…"
        InputProps={{
          startAdornment: <SearchIcon fontSize="small" />,
          endAdornment: (
            <IconButton
              title="Clear"
              aria-label="Clear"
              size="small"
              style={{ visibility: props.value ? "visible" : "hidden" }}
              onClick={props.clearSearch}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          )
        }}
        sx={{
          width: {
            xs: 1,
            sm: "auto"
          },
          m: theme => theme.spacing(1, 0.5, 1.5),
          "& .MuiSvgIcon-root": {
            mr: 0.5
          },
          "& .MuiInput-underline:before": {
            borderBottom: 1,
            borderColor: "divider"
          }
        }}
      />
      <Button
        variant="outlined"
        size="small"
        style={{ width: "150px", float: "right" }}
        onClick={() => props.setOpenFormDialog(true)}
      >
        Create User
      </Button>
    </Box>
  );
}

ToolBar.propTypes = {
  setOpenFormDialog: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired
};

export default ToolBar;
